import {TrmzFile, TrmzMedium} from "@web-libs/features/files/trmz-file/domain/trmz-file.types";
import {FILE_UPLOAD_TYPE, TrmzFileDTO} from "@web-libs/features/files/trmz-file/api/trmz-file.types";
import {urlWithSlash} from "@web-libs/util/urls/url.functions";
import {parseDTOToFile, parseDTOtoMedium,} from "@web-libs/features/files/trmz-file/api/trmz-file-conversion.functions";

export interface TrmzFileDTOConverter {
    parseDTOToFile(dto: TrmzFileDTO): TrmzFile;
    parseDTOToMedium(dto: TrmzFileDTO): TrmzMedium;
    parseDTOToUrl(dto: TrmzFileDTO): string;
    getUrlByID(id: string, fileUploadType?: FILE_UPLOAD_TYPE): string;
    getChatUrl(fileId: string, roomId:string): string;
}

export type UrlConversionFunction = (id: string, fileUploadType?: FILE_UPLOAD_TYPE, width?:number) => string;

export const createTrmzFileDTOConverter = (baseUrl:string,tenantId?: string): TrmzFileDTOConverter => {

    const getUrl:UrlConversionFunction = (id: string, fileUploadType?: FILE_UPLOAD_TYPE, width?:number): string => {
        const path = fileUploadType ? 'public/files/download' : 'public/dir/files/download';
        const sanitizedPath = `${urlWithSlash(baseUrl)}${path}/${id}`;
        const pathWithTenant = tenantId ? `${sanitizedPath}?tenantId=${tenantId}` : sanitizedPath;
        return width ? `${pathWithTenant}&width=${width}` : pathWithTenant;
    }

    const getChatUrlById = (fileId: string, roomId:string): string => {
        const path = `rooms/${roomId}/chatMedia/download/${fileId}`;
        const sanitizedPath = `${urlWithSlash(baseUrl)}${path}`;
        return tenantId ? `${sanitizedPath}?tenantId=${tenantId}` : sanitizedPath;
    }

    return {
        parseDTOToFile: (dto: TrmzFileDTO): TrmzFile => parseDTOToFile(dto, getUrl),
        parseDTOToMedium: (dto: TrmzFileDTO): TrmzMedium => parseDTOtoMedium(dto, getUrl),
        parseDTOToUrl: (dto: TrmzFileDTO): string => parseDTOToFile(dto, getUrl).fileUrl,
        getUrlByID: getUrl,
        getChatUrl: getChatUrlById
    }
}


